<template lang="html">

  <div class="tecnologia">

   <section class="vh intro">
    <div class="bkg-pieza waypoints-instant -responsiveIntro" data="fadeInUp">
      <a href="#" v-scroll-to="'.cat-general'" class="scrolldown"></a>
      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft -introText">
        <div class="container-text">
          <h2 class="title title-52"  v-html="$t('tecnologia.titulo')"></h2>
          <p v-html="$t('tecnologia.entradilla')"></p>
           <a class="btn btn-light open-pop" @click="videoshow = true" v-html="$t('tecnologia.boton_video')"></a>
        </div>
      </div>
    </div>
    <video-visualizer :id="'unHmdr1Dpq0'" :show="videoshow" @closeVideo="videoshow=false"></video-visualizer>
   
  </section>

  <section class="cat-general sec-center pad-sec">
    <div class="container waypoints" data="fadeInUp">
      <p v-html="$t('tecnologia.lideres_descripcion')"></p>
      <router-link :to="$t('tecnologia.boton_descarga')"  target="_blank" class="btn btn-dark btn-center" v-html="$t('tecnologia.boton_como_funciona')"></router-link>
    </div>
    
  </section>
<section class="info-pil">
  <div class="container waypoints" data="fadeInUp">
      <p v-html="$t('tecnologia.text_lab_pila1')"></p>
      <p v-html="$t('tecnologia.text_lab_pila2')"></p>
     <img src="/static/img/tecnologia/pila.png" data="fadeInUp" class="waypoints">
    </div>
</section>
  <section class="aplicacion-pemfc">

    <div class="container row-between fww ais">
      <h2 class="title title-36" v-html="$t('tecnologia.aplicaciones_sistema')"></h2>
      <p v-html="$t('tecnologia.aplicaciones_descripcion')"></p>
    </div> 

  </section>
  
  
  <section class="stats">
    <h3 class="waypoints" data="fadeInUp" v-html="$t('tecnologia.banner_textos.autonomia')"></h3>
    <h3 class="waypoints" data="fadeInUp" v-html="$t('tecnologia.banner_textos.funcionamiento')"></h3>
    <h3 class="waypoints" data="fadeInUp" v-html="$t('tecnologia.banner_textos.mantenimiento')"></h3>
    <h3 class="waypoints" data="fadeInUp" v-html="$t('tecnologia.banner_textos.SAI')">)</h3>
    <h3 class="waypoints" data="fadeInUp" v-html="$t('tecnologia.banner_textos.medioambiente')"></h3>
  </section>


  <section class="proyecto-cat flex wrap justify-end align-stretch ais">
    <div class="cat-1 img-cat" data-value="bkg-cat1"></div>
    <div class="cat-1 desc-cat flex column justify-center">
      <h2 class="title title-36" v-html="$t('tecnologia.comunicacion_telefonia')"></h2>
      <p v-html="$t('tecnologia.comunicacion_description')"></p>
    </div>
  </section>

  <section class="proyecto-cat flex wrap justify-end align-stretch ais">
    <div class="cat-3 desc-cat flex column justify-center">
      <h2 class="title title-36" v-html="$t('tecnologia.proceso_datos')"></h2>
      <p v-html="$t('tecnologia.proceso_datos_description')"></p>
    </div>
    <div class="cat-3 img-cat" data-value="bkg-cat3"></div>
  </section>

  <section class="proyecto-cat flex wrap justify-end align-stretch ais">
    <div class="cat-4 img-cat" data-value="bkg-cat4"></div>
    <div class="cat-4 desc-cat flex column justify-center">
      <h2 class="title title-36" v-html="$t('tecnologia.servicio_emergencia')"></h2>
      <p v-html="$t('tecnologia.servicio_emergencia_description')"></p>
    </div>
  </section>

    <otras-secciones :data="['productos', 'proyectos']"></otras-secciones>

</div>


</template>

<script lang="js">

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';
  import videoVisualizer from '@/components/parts/video-visualizer';

  export default  {
    name: 'tecnologia',
    props: [],
    mounted() {

    },
    data() {
      return {
        videoshow : false
      }
    },
    methods: {

    },
    components: {
     'otras-secciones' : Otras_Secciones,
     'video-visualizer' : videoVisualizer
   }
 }
</script>

<style scoped  >
.tecnologia .intro {
  position: relative;
  height: auto;
  min-height: 100vh;
  background: url(/static/img/bkg/bkg-tecnologia.jpg) center/cover no-repeat;
}

.tecnologia .intro .col-50 {
  background: rgba(5, 66, 121, 0.9);
  height: 100vh;
}

.btn-center {
  max-width: 480px;
}

.aplicacion-pemfc {
  padding: 50px;
}

.aplicacion-pemfc .title {
  width: 50%;
  max-width: 350px;
}

.aplicacion-pemfc .title strong {
  font-family: "HalisGR-Book";
}

.aplicacion-pemfc p {
  width: 50%;
}

.stats {
  padding: 100px 50px;
  background: url(/static/img/bkg/bkg-stats-tecnologia.jpg) center/cover
    no-repeat;
}

.stats h3 {
  font-size: 36px;
  line-height: 1.22;
  letter-spacing: 1.1px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 40px;
}

.stats h3:nth-child(1) {
  animation-delay: 0.3s;
}
.stats h3:nth-child(2) {
  animation-delay: 0.5s;
}
.stats h3:nth-child(3) {
  animation-delay: 0.7s;
}
.stats h3:nth-child(4) {
  animation-delay: 0.9s;
}
.stats h3:nth-child(5) {
  animation-delay: 1s;
}

.stats h3:last-of-type {
  margin-bottom: 0;
}

.cat-4.img-cat {
  width: 50%;
  background: url(/static/img/tecnologia/torres.jpg) center/cover no-repeat;
}

.cat-4.desc-cat {
  width: 50%;
}

.cat-1.img-cat {
  background: url(/static/img/tecnologia/torres.jpg) center/cover no-repeat;
}

.cat-3.img-cat {
  background: url(/static/img/tecnologia/cpd.jpg) center/cover no-repeat;
}

.cat-4.img-cat {
  background: url(/static/img/tecnologia/hospitales.jpg) center/cover no-repeat;
}
.info-pil {
  background: url(/static/img/bkg-metal.jpg) no-repeat center/cover;
  padding: 60px 0;
  position: relative;
}
.info-pil p {
  padding-right: 420px;
  margin-bottom: 25px;
}
.info-pil p strong {
  font-weight: 700 !important;
}
.info-pil img {
  position: absolute;
  width: 100%;
  max-width: 420px;
  top: -120px;
  right: 0;
}
@media screen and (max-width: 1200px) {
  .proyecto-cat .desc-cat {
    width: 50%;
  }

  .proyecto-cat .img-cat {
    width: 50%;
  }
}
@media screen and (max-width: 1000px) {
  .info-pil {
    padding-bottom: 135px;
    margin-bottom: 70px;
  }
  .info-pil p {
    padding-right: 0;
    margin-bottom: 20px;
  }
  .info-pil img {
    position: absolute;
    width: 100%;
    max-width: 329px;
    top: 104%;
    right: 0;
    left: 0;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 800px) {
  .proyecto-cat {
    min-height: 0;
  }
}

@media screen and (max-width: 768px) {
  .aplicacion-pemfc .title {
    width: 100%;
    max-width: 100%;
  }

  .aplicacion-pemfc p {
    width: 100%;
  }

  .stats {
    padding: 50px 20px;
  }

  .stats h3 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .proyecto-cat .img-cat {
    width: 100%;
    height: 33.3333vh;
    -webkit-order: -1;
    -moz-order: -1;
    -ms-order: -1;
    -o-order: -1;
    order: -1;
  }

  .proyecto-cat .desc-cat {
    width: 100%;
    min-height: 0;
  }
}

@media screen and (max-width: 500px) {
  .aplicacion-pemfc {
    padding: 50px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/tecnologia.vue